
import React from 'react'
import { useCreateTagMutation } from '../Service/tagsApi';
import { tagFields } from '../fields';
import { Tag } from '../Types/tagsType';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { TagsRoutes } from '../../../Router/path';
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types';
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import theme from '../../../theme';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InfoIcon from '@mui/icons-material/Info';
import { tagValues } from '../initialValues';

const CreateTag = () => {
    const [createTag, createStatus] = useCreateTagMutation();


    const entityForm = useEntityForm<Tag>({
        initialData: tagValues,
        fields: tagFields,
        submitFn: (data) => createTag(data).unwrap(),
        redirectUrl: TagsRoutes.root,
        title: 'Utwórz tag',
        icon: <LocalOfferIcon />,
        backUrl: TagsRoutes.root,
        mutationStatus: createStatus,
        groupOrder: [FormRenderGroupTypes.basic],
        groupIcons: {
            Podstawowe: <InfoIcon sx={{ color: theme.palette.primary.main }} />,
        },
        showSuccessBeforeRedirect: true,
        redirectDelay: 2000,

    })

    return (
        <><EntityFormLayout {...entityForm}></EntityFormLayout></>
    )
}

export default CreateTag